import { v4 as uuidv4 } from "uuid";


export const DEFAULT_NEW_DATA = {
  username: uuidv4(),
  name: null,
  role: null,
  isSaved: false,
};
